import { Controller } from 'stimulus'
import { fireConfirmPopup, fireToast } from '../helpers'

export default class extends Controller {
  static targets = ['attached', 'images']

  removeAttached(e) {
    const removeItem = e.currentTarget.parentElement.parentElement.parentElement
    const destroyAttachedPath = e.currentTarget.dataset.destroyAttachedPath;
    fireConfirmPopup({text: 'Vas a eliminar un archivo'})
    .then(isConfirmed => {
      if (isConfirmed) {

        Rails.ajax({
          type: "post",
          dataType: 'json',
          url: destroyAttachedPath,
          success: (data) => {
            removeItem.remove();
            fireToast({
              icon: 'success',
              title: 'Se elimino exitosamente el archivo'
            })
          },
          error: function(data) { alert('Error: no Deal File match this ID') }
        })
      }
    });
  }

  appendAttachments(e) {
    const [data, status, xhr] = e.detail;
    this.imagesTarget.innerHTML += xhr.response;
    if (status == "OK"){
      fireToast({
        icon: 'success',
        title: 'Se agrego exitosamente el archivo'
      })
    }else{
      fireToast({
        title: 'Uno o mas archivos no cumplen con los requisitos'
      })
    }
  }

  addAttached(e) {
    let card = e.currentTarget.parentElement.parentElement;
    let destroyAttachedPath = e.currentTarget.dataset.destroyAttachedPath;

    Rails.ajax({
      type: "post",
      dataType: 'json',
      url: destroyAttachedPath,
      success: (data) => {
        card.remove();
        fireToast({
          icon: 'success',
          title: 'Se agrego exitosamente el archivo'
        })
      },
      error: function(data) { alert('Error: no Deal File match this ID') }
    })
  }
}
